import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { alpha, Box, Typography, useTheme } from '@mui/material'

export interface CustomUserResponseBoxProps {
  readonly content: string
  readonly label?: string
  readonly color?: string
}

export const CustomUserResponseBox: FC<CustomUserResponseBoxProps> = ({
  content,
  label,
  color,
}) => {
  const theme = useTheme()
  const borderColor = color || theme.palette.info.main

  return (
    <Box sx={containerSx}>
      {label && <Typography sx={labelSx}>{label}</Typography>}
      <Box sx={contentBoxSx(borderColor)}>
        <Typography sx={contentTextSx}>{content}</Typography>
      </Box>
    </Box>
  )
}

const containerSx: SxProps<Theme> = {
  mt: 1,
  mb: 1,
}

const labelSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontStyle: 'italic',
  display: 'block',
  mb: 0.5,
  fontSize: 'inherit',
}

const contentBoxSx = (borderColor: string): SxProps<Theme> => ({
  p: 1.5,
  backgroundColor: 'transparent',
  borderRight: `3px solid ${alpha(borderColor, 0.6)}`,
  borderRadius: 0,
})

const contentTextSx: SxProps<Theme> = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  lineHeight: 1.6,
  fontSize: 'inherit',
}
